import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const GOLD = '#C9A84C';
const BG = '#050810';
const SURFACE = '#0B1120';
const BORDER = 'rgba(255,255,255,0.07)';
const OFF_WHITE = '#A0AABB';
const RED = '#FF4444';
const GREEN = '#22C55E';

const s = {
  page: {
    background: BG,
    color: '#fff',
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
    minHeight: '100vh',
  },
  wrap: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '72px 24px 80px',
  },
  badge: {
    display: 'inline-block',
    background: 'rgba(201,168,76,0.12)',
    border: '1px solid rgba(201,168,76,0.3)',
    color: GOLD,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    padding: '6px 14px',
    borderRadius: 20,
    marginBottom: 24,
  },
  h1: {
    fontSize: 'clamp(28px,5vw,42px)',
    fontWeight: 800,
    margin: '0 0 16px',
    lineHeight: 1.15,
  },
  sub: {
    color: OFF_WHITE,
    fontSize: 17,
    lineHeight: 1.7,
    margin: '0 0 56px',
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: OFF_WHITE,
    marginBottom: 20,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: 48,
  },
  thMane: {
    background: 'rgba(201,168,76,0.1)',
    color: GOLD,
    fontWeight: 700,
    fontSize: 13,
    padding: '14px 20px',
    textAlign: 'left',
    border: '1px solid rgba(201,168,76,0.2)',
    borderBottom: `2px solid ${GOLD}`,
  },
  thComp: {
    background: SURFACE,
    color: OFF_WHITE,
    fontWeight: 700,
    fontSize: 13,
    padding: '14px 20px',
    textAlign: 'left',
    border: `1px solid ${BORDER}`,
  },
  thLabel: {
    background: 'transparent',
    color: OFF_WHITE,
    fontWeight: 600,
    fontSize: 12,
    padding: '14px 0',
    textAlign: 'left',
    letterSpacing: '0.04em',
    border: 'none',
    borderBottom: `1px solid ${BORDER}`,
  },
  tdLabel: {
    color: OFF_WHITE,
    fontSize: 14,
    padding: '16px 0',
    borderBottom: `1px solid ${BORDER}`,
    fontWeight: 500,
    verticalAlign: 'top',
  },
  tdMane: {
    color: '#fff',
    fontSize: 14,
    padding: '16px 20px',
    borderBottom: '1px solid rgba(201,168,76,0.15)',
    background: 'rgba(201,168,76,0.04)',
    border: '1px solid rgba(201,168,76,0.1)',
    verticalAlign: 'top',
  },
  tdComp: {
    color: OFF_WHITE,
    fontSize: 14,
    padding: '16px 20px',
    borderBottom: `1px solid ${BORDER}`,
    background: SURFACE,
    border: `1px solid ${BORDER}`,
    verticalAlign: 'top',
  },
  callout: {
    background: 'rgba(201,168,76,0.07)',
    border: '1px solid rgba(201,168,76,0.25)',
    borderRadius: 12,
    padding: '28px 32px',
    marginBottom: 48,
  },
  calloutLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: GOLD,
    marginBottom: 12,
  },
  calloutText: {
    color: '#fff',
    fontSize: 16,
    lineHeight: 1.8,
    margin: 0,
  },
  faqItem: {
    borderBottom: `1px solid ${BORDER}`,
    paddingBottom: 28,
    marginBottom: 28,
  },
  faqQ: {
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    marginBottom: 10,
  },
  faqA: {
    color: OFF_WHITE,
    fontSize: 15,
    lineHeight: 1.7,
    margin: 0,
  },
  cta: {
    background: 'rgba(201,168,76,0.07)',
    border: '1px solid rgba(201,168,76,0.25)',
    borderRadius: 16,
    padding: '48px 40px',
    textAlign: 'center',
    marginTop: 56,
  },
  ctaTitle: {
    fontSize: 24,
    fontWeight: 800,
    marginBottom: 12,
  },
  ctaSub: {
    color: OFF_WHITE,
    fontSize: 15,
    lineHeight: 1.6,
    marginBottom: 32,
  },
  btn: {
    display: 'inline-block',
    background: GOLD,
    color: '#000',
    fontWeight: 800,
    fontSize: 14,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '16px 40px',
    borderRadius: 8,
    textDecoration: 'none',
  },
};

const rows = [
  {
    label: 'Monthly Price',
    mane: '$29/mo — locked forever',
    comp: <span>"Free" — $0/mo base<br /><span style={{ fontSize: 12, color: OFF_WHITE }}>Revenue comes from commissions and payment fees</span></span>,
  },
  {
    label: 'Commission on New Clients',
    mane: <span style={{ color: GREEN }}>0% — always</span>,
    comp: <span style={{ color: RED }}>20% commission on new clients from marketplace<br /><span style={{ fontSize: 12 }}>Fresha keeps a cut of clients they send you</span></span>,
  },
  {
    label: 'Payment Processing',
    mane: <span style={{ color: GREEN }}>Standard Stripe (2.9% + 30c)</span>,
    comp: <span style={{ color: RED }}>2.19% + 20c — but mandatory<br /><span style={{ fontSize: 12 }}>Must use Fresha Payments on all transactions</span></span>,
  },
  {
    label: 'No-Show Protection Fee',
    mane: <span style={{ color: GREEN }}>Included — no extra charge</span>,
    comp: <span style={{ color: RED }}>Charges client a fee, Fresha takes a cut</span>,
  },
  {
    label: 'Client Data Ownership',
    mane: <span style={{ color: GREEN }}>Yours. Export anytime.</span>,
    comp: <span style={{ color: RED }}>Clients are in Fresha's marketplace. They can book anyone.</span>,
  },
  {
    label: 'AI Re-Engagement',
    mane: <span style={{ color: GREEN }}>Included — auto win-back messages</span>,
    comp: <span style={{ color: RED }}>Not available</span>,
  },
  {
    label: 'SMS / Email Marketing',
    mane: <span style={{ color: GREEN }}>Included</span>,
    comp: <span style={{ color: RED }}>Blast messages cost extra — pay per message</span>,
  },
  {
    label: 'Product Sales Commission',
    mane: <span style={{ color: GREEN }}>0%</span>,
    comp: <span style={{ color: RED }}>20% on product sales through the platform</span>,
  },
  {
    label: 'Contract',
    mane: 'Month-to-month',
    comp: '"Free" but locked into their payment ecosystem',
  },
];

const faqs = [
  {
    q: 'If Fresha is free, why switch?',
    a: "Fresha is free the way social media is free — you're the product. They take 20% commission on every new marketplace client, mandatory payment processing fees on every transaction, and charge per-message for SMS marketing. A busy stylist doing $10,000/mo can easily pay $300-500/mo in Fresha fees. That's not free. That's expensive with good marketing.",
  },
  {
    q: 'How does Fresha actually make money?',
    a: "Three ways: mandatory payment processing (2.19% + 20c on every transaction), 20% commission on new marketplace clients, and paid add-ons like blast messages and no-show protection. They also take 20% on product sales. The 'free' model is designed so you never see a bill — but you always pay.",
  },
  {
    q: "Does Fresha own my client relationships?",
    a: "Effectively, yes. Clients who find you through Fresha's marketplace can see and book every other professional near them. Fresha doesn't help you build loyalty — they help clients comparison-shop. Your clients are their marketplace. With Mane, clients book through YOUR link. They see YOUR services. There's no competitor sidebar.",
  },
  {
    q: "What does Fresha have that Mane doesn't?",
    a: "Fresha has a large consumer marketplace — clients can discover you by searching their app. They also have a built-in POS for product sales and a broader international presence. If you have zero clients and need discovery, Fresha's marketplace has value (at 20% per new client). If you already have clients and want to keep 100% of your revenue, Mane is the better choice.",
  },
  {
    q: "What happens to my price if Mane raises rates?",
    a: "Founding members are locked at $29/mo for life. That's in your membership agreement. When we raise prices for new members, your rate doesn't move. Ever.",
  },
];

export default function VsFresha() {
  return (
    <div style={s.page}>
      <Helmet>
        <title>Mane vs. Fresha — The "Free" Trap Explained</title>
        <meta name="description" content="Fresha is 'free' but takes 20% on new clients, mandatory payment processing fees, and charges for SMS. Here's what free actually costs you." />
        <meta property="og:title" content='Mane vs. Fresha — The "Free" Trap Explained' />
        <meta property="og:description" content="Fresha's free model hides 20% commissions, mandatory processing fees, and per-message charges. Here's the real math." />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content="https://joinmane.com/og-image-v8.png" />
      </Helmet>
      <div style={s.wrap}>
        <div style={s.badge}>Mane vs. Fresha</div>
        <h1 style={s.h1}>"Free" is the most expensive word in booking software.</h1>
        <p style={s.sub}>
          Fresha doesn't charge a monthly fee. Instead, they take a piece of every transaction,
          every new client, and every marketing message. By the time you add it up, "free"
          costs more than most paid platforms.
        </p>

        <div style={s.sectionTitle}>Side-by-side breakdown</div>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.thLabel}></th>
              <th style={s.thMane}>Mane (Founding)</th>
              <th style={s.thComp}>Fresha</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td style={s.tdLabel}>{r.label}</td>
                <td style={s.tdMane}>{r.mane}</td>
                <td style={s.tdComp}>{r.comp}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={s.callout}>
          <div style={s.calloutLabel}>The "free" math</div>
          <p style={s.calloutText}>
            Esthetician doing $8,000/mo. Gets 5 new marketplace clients/mo (avg $120 first visit).<br />
            Fresha: 20% on new clients = $120. Processing 2.19% on $8,000 = $175. SMS blasts = ~$30.<br />
            Total: <strong style={{ color: RED }}>$325/mo for a "free" platform.</strong><br /><br />
            Mane founding rate: <strong style={{ color: GREEN }}>$29/mo. That's it.</strong><br />
            You save <strong style={{ color: GREEN }}>$296/mo</strong> — <strong style={{ color: GREEN }}>$3,552/year</strong>.
          </p>
        </div>

        <div style={s.sectionTitle}>Common questions</div>
        {faqs.map((f, i) => (
          <div key={i} style={s.faqItem}>
            <div style={s.faqQ}>{f.q}</div>
            <p style={s.faqA}>{f.a}</p>
          </div>
        ))}

        <div style={s.cta}>
          <div style={s.ctaTitle}>Pay a flat rate. Keep everything else.</div>
          <p style={s.ctaSub}>
            50 founding spots. Pay $199 once, then $29/mo locked for life.<br />
            When the spots fill, the price goes to $59/mo — no exceptions.
          </p>
          <Link to="/founding" style={s.btn}>Claim Your Founding Spot</Link>
          <p style={{ color: OFF_WHITE, fontSize: 13, marginTop: 20 }}>
            Questions? <a href="mailto:christiangflairbiz@gmail.com" style={{ color: GOLD }}>Email Christian directly.</a> He answers.
          </p>
        </div>
      </div>
    </div>
  );
}
